<template>
	<el-upload ref="upload" v-bind="$attrs">
		<slot />
		<template v-for="(value, name) in $scopedSlots" :slot="name" slot-scope="slotData">
			<slot :name="name" v-bind="slotData" />
		</template>
	</el-upload>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsUpload',
});
</script>
